'use strict';

module.exports = function square(options = {}) {
    return this.multiply(this, options);
};



// WEBPACK FOOTER //
// ../isotopic-distribution/src/utils/square.js